
// SVG Icon: minus
export default { id: "terriajs-minus" };
export const id = "terriajs-minus";
export const name = "minus";
